module.exports = __webpack_public_path__ + "static/media/inspect-exterior-logo.542dac8e.gif";